import { render, staticRenderFns } from "./materialSubTypeSideView.vue?vue&type=template&id=57d197d7"
import script from "./materialSubTypeSideView.vue?vue&type=script&lang=js"
export * from "./materialSubTypeSideView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports